/**
 * Gate.io Exchange Metadata
 */

import { GATE_WS_CHANNELS, GATE_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const GATE_METADATA = {
  id: 'gate' as ExchangeId,
  restDocs: ['https://www.gate.io/docs/developers/apiv4/en/'],
  wsDocs: ['https://www.gate.io/docs/developers/apiv4/ws/en/'],
  wsTopology: GATE_WS_TOPOLOGY,
  wsChannels: GATE_WS_CHANNELS,
  notes: [
    'JSON-RPC WebSocket; send manual ping payloads roughly every 30 seconds.',
    'REST endpoints require a CORS workaround when executed from browsers.',
  ],
} as const;
